module.exports = __webpack_public_path__ + "static/img/logo-ht.05361bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-ht.png
// module id = je3f
// module chunks = 126